import { Box } from '@mui/system';
import {
	DataGrid,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';

const FrequencyDataGrid = (props) => {
	const csv = props.csv;
	const { readString } = usePapaParse();
	const [data, setData] = useState([]);

	const handleReadString = () => {
		readString(csv, {
			complete: (results, file) => {
				setData((prevState) => {
					results.data.map((d, idx) => {
						d.id = idx;
					});
					return results.data;
				});
			},
			download: true,
			header: true,
			dynamicTyping: true,
			error: (error, file) => {
				console.log('Error while parsing:', error, file);
			}
		});
	};

	useEffect(() => {
		handleReadString();
	}, []);

	const cols = [
		{ field: 'Report name', headerName: 'Pesticide', flex: 1, minWidth: 100 },
		{
			field: 'Total number of results_sum',
			type: 'number',
			headerName: 'Total results',
			flex: 1,
			minWidth: 100
		},
		{
			field: 'Above legal limit result_sum',
			headerName: 'Above legal limit',
			flex: 1,
			minWidth: 100,
		},
		{ field: 'Proportion', headerName: 'Percentage (%)', flex: 1, minWidth: 100 },
	];

	function CustomToolbar() {
		return (
			<GridToolbarContainer>
				<GridToolbarColumnsButton
					sx={{
						color: '#1F2442',
						span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
					}}
				/>
				<GridToolbarFilterButton
					sx={{
						color: '#1F2442',
						span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
					}}
				/>
				<GridToolbarDensitySelector
					sx={{
						color: '#1F2442',
						span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
					}}
				/>
				<GridToolbarExport
					sx={{
						color: '#1F2442',
						span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
					}}
				/>
			</GridToolbarContainer>
		);
	}
	return (
		<Box sx={{ height: 350, marginBottom: '4rem' }}>
			<p style={{ marginBottom: '.5rem' }}>{props.title}</p>
			<DataGrid
				columns={cols}
				rows={data}
				components={{
					Toolbar: CustomToolbar
				}}
			/>
		</Box>
	);
};

export default FrequencyDataGrid;
